import { Component, Input } from '@angular/core';
import { ModalRef } from '@shared/ui';

@Component({
  template: `
    <fl-modal-title>Wanna award a project {{userId}}?</fl-modal-title>
    <fl-modal-content>
      Need a logo or whathever?
    </fl-modal-content>
    <fl-modal-actions>
      <fl-button>Yes</fl-button>
      <fl-button (click)="close()">No</fl-button>
    </fl-modal-actions>
  `,
})
export class AwardModalComponent {
  @Input() userId: number;

  // TODO: create a custom injector to be used inside modals
  constructor(private modalRef: ModalRef<AwardModalComponent>) {
    console.log(this.modalRef);
  }

  close() {
    this.modalRef.close();
  }
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/pl/webapp/src/app/projects/award-modal/award-modal.component.ts